import update from 'immutability-helper';
import _ from 'lodash';
import {
    SET_RETURN_MODEL,
    RETURN_MODEL_UPDATED_BY_FORM,
    RETURN_MODEL_ADDRESS_UPDATED_BY_FORM,
    RETURN_MODEL_LINE_QUANTITY_CHANGED_BY_FORM
} from '../actions/types'

export default function returnStore(state = {
    model: {
        header: {
            reference: '',
            po: '',
            bill_to: {},
            ship_to: {}
        },
        lines: []
    }
}, action = {}) {
    switch(action.type) {
        case SET_RETURN_MODEL:
            return update(state, {
                model: {$set: action.payload}
            });

        case RETURN_MODEL_UPDATED_BY_FORM:
            return update(state, {
                model: {
                    header: {
                        [action.payload.field]: {$set: action.payload.value}
                    }
                }
            });
        
        case RETURN_MODEL_ADDRESS_UPDATED_BY_FORM:
            return update(state, {
                model: {
                    header: {
                        [action.payload.type]: {
                            [action.payload.field]: {$set: action.payload.value}
                        }
                    }
                }
            });

        case RETURN_MODEL_LINE_QUANTITY_CHANGED_BY_FORM:
            const {rtnLine, newQty} = action.payload;
            const index = _.findIndex(state.model.lines, i => {
                return i.uid === rtnLine.uid;
            });
            if (index > -1) {
                return update(state, {
                    model: {
                        lines: {
                            [index]: {
                                qty: {$set: newQty}
                            }
                        }
                    }
                });
            }

            return state;

        default: return state;
    }
}


// WEBPACK FOOTER //
// ./src/stores/return.js